/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <div class="lampblackpage" ref="lampblackPage" :style="{ height: bodyHeight + 'px' }">
        <!-- 内容区域 -->
        <Row :gutter="20">
          <i-col span="6">
            <div class="leftbox" :style="{ height: bodyHeight + 'px' }">
              <div class="linehr"></div>
              <Spin v-if="treeLoading" fix>
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                <div>菜单加载中...</div>
              </Spin>
              <Input
                style="width: 90%; flex: none"
                @on-enter="getTreeInfo"
                v-model="seachCName"
                class="tabdiv"
                placeholder="搜索企业"
              >
                <span slot="append" @click="getTreeInfo"><Icon type="ios-search-outline" /></span>
              </Input>

              <div class="treedivbox">
                <el-tree
                  ref="treeBox"
                  node-key="keyID"
                  :data="treeData"
                  :default-expanded-keys="expandedKeys"
                  :props="defaultProps"
                  :highlight-current="true"
                  :render-content="renderContent"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
          </i-col>
          <i-col span="18">
            <div class="rightdivbox" :style="{ height: bodyHeight + 'px' }">
              <div class="company_text">{{ companyName || '' }}</div>
              <div class="contentbox">
                <div class="boxinterval">
                  <div class="realtop">
                    <div class="realtext">实时油烟</div>
                    <div class="timesline">
                      <Icon class="iconclock" type="md-time" />
                      监测时间：{{ yyNowData.time || '离线' }}
                    </div>
                  </div>
                  <template v-if="dataList && dataList.length">
                    <div class="realbottom">
                      <!-- status 0 正常  1 低于 2 高于 正常背景 iconcolor1 异常 iconcolor2-->

                      <div class="itemoptbox" v-for="(item, index) in dataList" :key="index">
                        <div class="itemtitle">
                          <div class="devicon" :class="item.status == 0 ? 'iconcolor1' : 'iconcolor2'">
                            <i class="iconfont" :class="item.icon"></i>
                          </div>
                          <div class="devtext">{{ item.cn_name || '' }}</div>
                        </div>
                        <!-- 正常 normalcolor  异常 warningcolor -->
                        <div class="itemline">
                          <div class="linedata warningcolor" v-if="item.status == 1">
                            <span v-if="item.unit == '开/关'">{{
                              item.value == 1 || item.value == '1' ? '开' : '关'
                            }}</span>
                            <span v-else>{{ item.value }}{{ item.unit }}</span>
                            <i class="icon iconfont icon-down" style="font-size: 14px" />
                          </div>
                          <div class="linedata warningcolor" v-else-if="item.status == 2">
                            <span v-if="item.unit == '开/关'">{{
                              item.value == 1 || item.value == '1' ? '开' : '关'
                            }}</span>
                            <span v-else>{{ item.value }}{{ item.unit }}</span>
                            <i class="icon iconfont icon-up-copy" style="font-size: 14px" />
                          </div>
                          <div class="linedata normalcolor" v-else>
                            <span v-if="item.unit == '开/关'">{{
                              item.value == 1 || item.value == '1' ? '开' : '关'
                            }}</span>
                            <span v-else>{{ item.value }}{{ item.unit }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <nullData v-else></nullData>
                </div>

                <!-- 历史工况 -->
                <div class="boxinterval historyradius">
                  <div class="historybox">
                    <div class="historyleft">
                      <div class="historytext">历史油烟</div>
                      <historyTimeChange
                        :yearTime="yearName"
                        :createTime="createTime"
                        @sendChangeTime="changeYear"
                      ></historyTimeChange>
                    </div>
                    <div class="historyright">
                      <DatePicker
                        placement="top-end"
                        v-model="timeRange"
                        type="datetimerange"
                        placeholder="请选择时间"
                        :editable="false"
                        format="yyyy-MM-dd"
                        style="width: 200px; margin-right: 10px"
                      />
                      <Button type="primary" ghost @click="exportFile"><i class="iconfont icon-daochu"></i>导出</Button>
                    </div>
                  </div>

                  <!-- 数据表格 -->
                  <i-table width="100%" :columns="columns2" :data="yyTableList" :loading="tbLoading" />
                  <!-- 分页 -->
                  <Page
                    style="margin-top: 0.625rem"
                    show-total
                    :current.sync="page"
                    :page-size-opts="[20, 50, 100, 200]"
                    :page-size="row"
                    :total="total"
                    show-sizer
                    @on-change="onNextPage"
                    @on-page-size-change="onPageSize"
                  />
                </div>
              </div>
            </div>
          </i-col>
        </Row>
      </div>
    </X-Layout>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import { createTree } from '@/common/common.js';
import { mathEleHeight, exportExcel, overMonth } from '@/utils/common';
import nullData from '@/components/nullData.vue';
import { parseTime } from '@/utils/date.js';
// 历史年选择
import historyTimeChange from '@/components/historyTimeChange.vue';
export default {
  components: {
    nullData,
    historyTimeChange,
  },
  data() {
    return {
      todayYear: '',
      createTime: '', // 公司创建时间
      compnayId: '', // 当前选中的公司id
      yearName: '', // 历史在线时间
      bodyHeight: '', // 主框的高度
      timeRange: [],
      companyName: '', // 公司名称
      checkId: '',
      activeFlag: 'name1', // 被选中的选项
      dataList: [], // 实时
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'childrens',
        label: 'title',
      },
      expandedKeys: [], // 指定树菜单展开key
      treeData: [], // 树菜单数据
      treeLoading: false, // 树菜单加载动画
      dataInfoLoading: false, // 信息加载动画
      yyNowData: {
        // 实时油烟数据
        time: '离线', // 监测时间
        fjkg: '', // 风机开关
        fjdl: '', // 风机电流
        jhqkg: '', // 净化器开关
        jhqdl: '', // 净化器电流
        yqsd: '', // 油烟湿度
        yynd: '', // 油烟浓度
        yqwd: '', // 油烟温度
        url: [], // 现场照片
      },
      comids: '',
      gkSite_id: '', // 排口id
      listindex: '', // 删除数组中的第几个数据
      seachCName: '', // 搜索企业名
      tbLoading: false, // 数据表的加载动画开关
      total: 0, // 总数
      page: 1, // 当前第一页
      row: 20, // 每页多少数据
      columns2: [
        // 表格列名
      ],
      yyTableList: [], // 油烟表格数据
    };
  },
  destroyed() {
    window.onresize = '';
  },
  mounted() {
    // 获取当年年份
    this.yearName = this.todayYear = Number(parseTime(new Date(), '{y}'));
    // 获取当前主框的高度
    // lampblackPage
    this.$nextTick(() => {
      this.getBodyHeight();
    });

    window.onresize = () => {
      this.getBodyHeight();
    };

    this.comids = this.$route.params.id ? this.$route.params.id : null; // 有传入公司ID
    this.getTreeInfo(); // 执行初始化树菜单
  },

  methods: {
    changeYear(e) {
      this.yearName = e;
      this.page = 1;
      this.getYYHistoryInfo();
    },
    getBodyHeight() {
      this.bodyHeight = mathEleHeight(this.$refs.lampblackPage, 20);
    },
    // 导出文件
    exportFile() {
      if (!this.timeRange[0]) {
        this.$Message.warning('请选择时间段');
        return;
      }

      if (!this.gkSite_id) {
        this.$Message.warning('请选择排口');
        return;
      }

      // 不要超过四个月
      if (!overMonth(this.timeRange[0], this.timeRange[1], 4)) {
        this.$Message.warning('选择的日期请不要超过4个月');
        return;
      }

      exportExcel(this.compnayId, this.gkSite_id, this.timeRange[0], this.timeRange[1], this);
    },
    /**
     * 树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContent: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 街道显示数量 报警变色
          if (data.streetStatus === 1 || data.streetStatus === 2) {
            return (
              <span style="font-size: 14px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
                <span></span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 2: // 第2层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 14px;color:red;">
                <i class={data.icon}></i>
                <Badge count={data.num1}>
                  <span style="padding-left: 4px;">{node.label}</span>
                </Badge>
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
        case 3: // 第3层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            // <i class={data.icon}></i>
            return (
              <span style="font-size: 14px;color:red;">
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
          }
      }
    },
    /**
     * 渲染树菜单 根据树菜单要求处理传入得到list数据
     */
    handleTreeList(list) {
      const _warrSite_ids = []; // 用于记录传入公司id时 记录所有报警排口的id集合
      const compayNameList = []; // 记录公司名
      let historyTime = ''; // 公司时间
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单 【街道】
        list[i].title = list[i].street_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-quyu'; // 新添icon字段 街道图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].street_id; // 添加一个唯一ID 用于展开使用 ；  '1'+ 是为了 1层、2层、3层没有相同的ID
        list[i].childrens = list[i].companylist; // 添加用于树菜单的childrens子级名

        // 处理2级菜单 判断一下是否有childrens节点
        if (list[i].childrens) {
          // 循环第二级数据 添加数据 【公司】
          for (let j = 0; j < list[i].childrens.length; j++) {
            list[i].childrens[j].title = list[i].childrens[j].company_name; // 新添title字段 树菜单显示标题
            list[i].childrens[j].icon = 'icon iconfont icon-jiudian'; // 新添icon字段 企业图标
            list[i].childrens[j].level = 2; // 添加层级 当前第1层 用于点击事件判断用
            list[i].childrens[j].keyID = '2' + list[i].childrens[j].company_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了  1层、2层、3层没有相同的ID
            list[i].childrens[j].childrens = list[i].childrens[j].siteid_list; // 添加用于树菜单的childrens子级名

            // 处理3级菜单 判断一下是否有childrens节点
            if (list[i].childrens[j].childrens) {
              // 循环第三级数据 添加数据 【排口】
              for (let k = 0; k < list[i].childrens[j].childrens.length; k++) {
                list[i].childrens[j].childrens[k].title = list[i].childrens[j].childrens[k].gkSite_name; // 新添title字段 树菜单显示标题
                list[i].childrens[j].childrens[k].icon = 'icon iconfont icon-youyanji1'; // 新添icon字段 排口图标
                list[i].childrens[j].childrens[k].company = list[i].childrens[j].company_name;
                list[i].childrens[j].childrens[k].level = 3; // 添加层级 当前第1层 用于点击事件判断用
                list[i].childrens[j].childrens[k].keyID = '3' + list[i].childrens[j].childrens[k].gkSite_id; // 添加一个唯一ID 用于展开使用；  '3'+ 是为了  1层、2层、3层没有相同的ID
                list[i].childrens[j].childrens[k].keyTime = parseTime(list[i].childrens[j].time, '{y}');
                list[i].childrens[j].childrens[k].companyId = list[i].childrens[j].company_id;
                // 记录报警排口
                if (this.comids === list[i].childrens[j].company_id) {
                  // 先判断是否传入的当前公司id
                  if (list[i].childrens[j].childrens[k].status === 1) {
                    // 判断当前排口为报警状态
                    _warrSite_ids.push(list[i].childrens[j].childrens[k].gkSite_id); // 记录排口id
                    compayNameList.push(
                      list[i].childrens[j].company_name + ' - ' + list[i].childrens[j].childrens[k].gkSite_name,
                    );
                  }
                }
              }
            }

            // 判断上面记录的 报警排口集合 如果是空的话 代表该公司下没有报警排口 那就默认第一个排口
            if (this.comids === list[i].childrens[j].company_id) {
              // 判断如果传入的公司id 等于 当前2层的公司id
              if (_warrSite_ids.length === 0) {
                _warrSite_ids.push(list[i].childrens[j].siteid_list[0].gkSite_id);
                compayNameList.push(
                  list[i].childrens[j].company_name + ' - ' + list[i].childrens[j].childrens[0].gkSite_name,
                );
                historyTime = list[i].childrens[j].childrens[0].keyTime;
              }
            }
          }
        }
      }
      this.treeData = list; // 处理好的list赋值树菜单渲染

      // // 判断是否 有传入公司ID 代表是首页跳转进来的
      if (this.comids) {
        this.compnayId = this.comids;
        this.expandedKeys.push('2' + this.$route.params.id); // 展开第2层 公司keyid  默认第1层也会对应展开   '2'+ 是区分是2层
        this.$nextTick(() => {
          // 树菜单 设置选中节点  treeBox 元素的ref
          this.$refs.treeBox.setCurrentKey('3' + _warrSite_ids[0]); // 取报警记录集合中的第1个排口id
        });
        this.gkSite_id = _warrSite_ids[0]; // 取报警记录集合中的第1个排口id
        this.companyName = compayNameList[0]; // 取名字
        this.createTime = historyTime;
      } else {
        // 默认设置第一个公司 节点和选中展开
        if (list[0]) {
          this.compnayId = list[0].childrens[0].childrens[0].companyId;
          this.createTime = list[0].childrens[0].childrens[0].keyTime;
          this.expandedKeys.push(list[0].keyID, list[0].childrens[0].keyID); // 展开第一个街道里的第一个公司节点的keyid
          this.$nextTick(() => {
            // 设置选中节点  treeBox 元素的ref
            this.$refs.treeBox.setCurrentKey(list[0].childrens[0].childrens[0].keyID); // 选中第一个排口
          });
          this.gkSite_id = list[0].childrens[0].childrens[0].gkSite_id; // 设置默认 第一个街道 第一个公司 第一个排口id
          this.companyName = list[0].childrens[0].company_name + ' - ' + list[0].childrens[0].childrens[0].gkSite_name;
        }
      }
    },
    /**
     * 初始化树菜单数据
     */
    getTreeInfo() {
      const api = this.ApiUrl + 'nowData/findAllYy1';
      const params = {
        companyName: this.seachCName,
      };
      this.treeLoading = true; // 开启加载动画
      this.dataInfoLoading = true; // 把信息页加载动画也开启
      // 请求接口
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            var list = res.data.extend.pageInfo;
            // 获取第一个渲染的id
            if (
              list.length > 0 &&
              list[0].companylist.length > 0 &&
              list[0].companylist[0].siteid_list.length > 0 &&
              list[0].companylist[0].siteid_list[0].gkSite_id
            ) {
              this.checkId = list[0].companylist[0].siteid_list[0].gkSite_id;
            }

            this.handleTreeList(res.data.extend.pageInfo); // 1.渲染树菜单

            this.getYYNowInfo(); // 2.执行【实时数据】
            this.getYYHistoryInfo(); // 3.执行初始化表格数据 【历史数据】
          }
          this.treeLoading = false; // 开启加载动画
        },
        res => {
          this.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 树菜单单击事件
     */
    handleNodeClick(data) {
      if (data.gkSite_id == this.checkId) {
        return;
      }

      this.checkId = data.gkSite_id;

      // 如果是第3层 就触发 表格事件
      if (data.level === 3) {
        this.compnayId = data.companyId;
        this.createTime = data.keyTime;
        this.yearName = this.todayYear;
        this.yyTableList = []; // 清空数据表
        this.dataList = []; // 清空实时数据
        this.yyNowData = {
          // 清空实时油烟数据
          time: '离线', // 监测时间
          url: [], // 现场照片
        };

        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.companyName = data.company + ' - ' + data.gkSite_name;
        this.page = 1; // 初始化 设置第一页
        // this.row = 20;// 初始化 20条数据
        this.total = 0; // 初始化总条数
        this.getYYNowInfo(); // 执行【实时数据】
        this.getYYHistoryInfo(); // 【历史数据】渲染表格
      }
    },
    /**
     * 搜索企业或者街道 更新树菜单
     */
    seach() {
      this.yyTableList = []; // 清空数据表
      this.gkSite_id = ''; // 清空排口
      this.total = 0; // 清空总数据
      this.yyNowData = {
        // 清空实时油烟数据
        time: '离线', // 监测时间

        url: [], // 现场照片
      };

      const api = this.ApiUrl + 'nowData/findYyAndGkCompanyLike';
      const data = {
        company_name: this.seachCName,
        type: 1,
      };
      this.treeLoading = true; // 开启加载动画

      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.handleTreeList(res.data.extend.pageInfo.records); // 1.渲染树菜单

            this.getYYNowInfo(); // 2.执行【实时数据】
            this.getYYHistoryInfo(); // 3.执行初始化表格数据 【历史数据】
          }
          this.treeLoading = false; // 开启加载动画
        },
        res => {
          this.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 得到油烟 【实时数据】
     */
    getYYNowInfo() {
      const apis = 'gkData/findByGkSiteId2';
      this.data = {
        time: this.formatDateTime1(new Date()),
        gkSite_id: this.gkSite_id,
        page: this.page,
        row: 999,
        type: 1,
      };

      this.dataInfoLoading = true; // 开启加载动画
      this.yyNowData.time = '';
      this.dataList = [];
      // 开启请求
      this.$http.post(this.ApiUrl + apis, this.data).then(
        res => {
          if (res.data.extend.news === 0 && res.data.extend.pageInfo.length > 0) {
            // // 赋值标图数据
            const list = res.data.extend.pageInfo;
            this.dataList = list;
            this.yyNowData.time = this.formatDateTime(list[0].receive_time); // 监测时间
            // 【实时数据】现场图片
            const picUrl = res.data.extend.picUrl;
            if (picUrl === null || picUrl.picUrl == '') {
              this.yyNowData.url = [{ url: '/images/nopic.gif' }]; // 默认没有图片显示系统设置图片
            } else {
              this.yyNowData.url = []; // 先清空
              if (picUrl.picUrl.match(',')) {
                picUrl.picUrl.split(',').forEach(element => {
                  this.yyNowData.url.push({ url: element });
                });
              } else {
                const url = { url: picUrl };
                this.yyNowData.url.push(url);
              }
            }
          }
          this.dataInfoLoading = false; // 关闭加载动画
        },
        res => {
          this.dataInfoLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 得到油烟 【历史数据】  渲染表格
     */
    getYYHistoryInfo() {
      const apis = 'gkData/findHistoryData';
      this.data = {
        gkSite_id: this.gkSite_id,
        page: this.page,
        row: this.row,
        type: 1,
        time: this.yearName,
      };

      this.tbLoading = true; // 开启加载动画
      this.yyTableList = [];
      this.columns2 = [];
      this.total = 0;

      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, this.data)
        .then(res => {
          if (res.data.extend.news === 0) {
            // 表中数据
            this.columns2 = [];
            this.columns2.push({
              type: 'index',
              title: '序号',
              align: 'center',
              minWidth: 90,
              indexMethod: row => {
                return row._index + 1 + this.page * this.row - this.row;
              },
            });
            this.yyTableList = res.data.extend.dataList;
            var titleList = ''; // 存放表头数据
            if (res.data.extend.tableTitle.length > 0) {
              titleList = res.data.extend.tableTitle;
            }

            for (var i = 0; i < titleList.length; i++) {
              let fiexdDir = '';
              if (titleList[i] == '监测时间') {
                fiexdDir = 'right';
              }

              this.columns2.push({
                title: titleList[i],
                align: 'center',
                fixed: fiexdDir,
                minWidth: fiexdDir ? 180 : 130,
                render: (h, params) => {
                  let _class = '';
                  let _class1 = '';
                  let opt = '';
                  let statuflag = '';
                  // 对比有无对应数据
                  const res = params.row.data.find(values => {
                    return values.name == params.column.title;
                  });
                  // 有对应数据
                  if (res) {
                    // 状态
                    statuflag = res.status;
                    // 数值
                    opt = res.value;
                  }
                  switch (
                    statuflag // 判断值 设置对应的样式
                  ) {
                    case 1:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-down demo-table-info-cell-value';
                      break;
                    case 2:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-up-copy demo-table-info-cell-value';
                      break;
                  }
                  return h('div', [h('span', { class: _class }, opt), h('i', { class: _class1 })]);
                },
              });
            }
            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        })
        .catch(err => {
          this.total = 0;
          this.tbLoading = false; // 关闭加载动画
        });
    },
    // 被选中项的事件(实时 name1 历史 name2)
    checkedTab() {
      if (this.activeFlag == 'name1' && this.dataList.length <= 0) {
        this.getYYNowInfo();
      } else if (this.activeFlag == 'name2' && this.yyTableList.length <= 0) {
        this.getYYHistoryInfo();
      }
    },

    // 切换显示的页数
    onPageSize(e) {
      this.yyTableList = [];
      this.row = e;
      this.page = 1;
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 切换下一页
    onNextPage(e) {
      this.yyTableList = [];
      this.page = e;
      this.getYYHistoryInfo(); // 执行油烟【历史数据】数据表
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.ivu-col-span-18 {
  padding-left: 5px !important;
}
/deep/ .ivu-badge-count {
  right: -9px !important;
  top: -4px;
  background-color: #ff5b5b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  z-index: 10;
}
</style>
<style scoped lang="scss">
.lampblackpage {
  overflow: hidden;
  .leftbox {
    background: #fff;
    padding: 0 15px;
    position: relative;
    padding-top: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 10px;
    border-radius: 8px 8px 0 0;
    .linehr {
      height: 6px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #0062ff;
      border-radius: 8px 8px 0 0;
    }
    .treedivbox {
      flex: 1;
      overflow-y: auto;
    }
    // 滚动条宽高
    .treedivbox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    // 滚动条背景颜色
    .treedivbox::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 5px;
    }
    // 滚动条颜色
    .treedivbox::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
    }
    // 鼠标移动到滚动条上颜色
    .treedivbox::-webkit-scrollbar-thumb:hover {
      background: rgb(122, 121, 121);
    }
  }
  .rightdivbox {
    display: flex;
    flex-direction: column;
  }

  .company_text {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: #0062ff;
    position: relative;
    height: 35px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1px;
    border-radius: 8px 8px 0 0;
  }
  .contentbox {
    flex: 1;
    overflow-y: auto;
  }

  .contentbox::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .contentbox::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 5px;
  }
  .contentbox::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }
  .contentbox::-webkit-scrollbar-thumb:hover {
    background: rgb(122, 121, 121);
  }

  .boxinterval {
    background: #fff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 0 0 8px 8px;
  }
  .historyradius {
    border-radius: 8px;
  }

  .realtop {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .realtext {
      display: flex;
      position: relative;
      padding-left: 14px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-right: 30px;
    }
    .realtext::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 4px;
      height: 14px;
      background-color: #0062ff;
      transform: translateY(-50%);
    }
    .timesline {
      display: flex;
      padding: 6px 8px;
      background-color: #0062ff;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border-radius: 4px;
      .iconclock {
        font-size: 15px;
        color: #fff;
        margin-right: 5px;
      }
    }
  }

  .realbottom {
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 15px 25px;
    margin-bottom: 15px;

    .itemoptbox {
      box-shadow: 0 0 4px #d1d0d0;
      background: #f5f5f5;
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      border-radius: 8px;
      .itemtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .devicon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          > i {
            color: #fff;
          }
        }

        .iconcolor1 {
          background-color: #19be6b;
        }
        .iconcolor2 {
          background-color: #e72d14;
        }

        .devtext {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .itemline {
        display: flex;
        justify-content: center;
        .linetit {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #5f788e;
        }
        .linedata {
          font-size: 18px;
          font-weight: bold;
          line-height: 28px;
        }
      }
    }
  }
  .historybox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .historyleft {
      display: flex;
      align-items: center;
      .historytext {
        padding-left: 9px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #233c52;
        margin-right: 20px;
      }
      .historytext::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #0062ff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .historyright {
      i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
.ivu-table {
  font-size: 14px;
}
.topbtn {
  display: flex;
}

.topbtn > div {
  margin-right: 20px;
}

.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.timebox {
  margin-top: 2px;
}

.changbox > button {
  border-radius: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.yyNow {
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  text-align: center;
}

.yyNow i {
  font-size: 36px;
}
.yyNow .ctime {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
}

.yyDiv {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}
.yyDiv .yyz {
  width: 100%;
  min-width: 900px;
  flex-shrink: 0;
}
.imgbox {
  padding-top: 2.5rem;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}
.imgbox img {
  width: 6.25rem;
  height: 6.25rem;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}
.boxStatus {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
  line-height: 26px;
}

.normal {
  background-color: #19be6b;
}

.exceed {
  background-color: #ed4014;
}
.iconcolor1 {
  background-color: #19be6b;
}
.iconcolor2 {
  background-color: #e72d14;
}

.normalcolor {
  color: #19be6b;
}
.warningcolor {
  color: #e72d14;
}
</style>
